import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/i18n";
import { ListChecks, Shuffle, Blocks, Headphones, BookOpen, ArrowRight } from "lucide-react";

const CARDS = [
  { key: "quizzes", to: "/quizzes", icon: ListChecks, color: "#E46A28", bg: "#FDEEE5" },
  { key: "match", to: "/practice/match", icon: Shuffle, color: "#0E5A35", bg: "#E4F0E9" },
  { key: "build", to: "/practice/build", icon: Blocks, color: "#1E429F", bg: "#E6ECFA" },
  { key: "listen", to: "/practice/listen", icon: Headphones, color: "#8A5A1E", bg: "#F6ECDD" },
  { key: "grammar", to: "/grammar", icon: BookOpen, color: "#7A2E2E", bg: "#F7E7E7" },
];

export default function PracticeHub() {
  const { t } = useI18n();
  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-14" data-testid="practice-hub">
      <h1 className="font-serif text-3xl sm:text-4xl font-semibold text-[#0E382B] tracking-tight">{t("hub.title")}</h1>
      <p className="mt-2 text-[#52635B] text-base">{t("hub.sub")}</p>

      <div className="mt-8 grid gap-5 sm:grid-cols-2">
        {CARDS.map(({ key, to, icon: Icon, color, bg }) => (
          <Link
            key={key}
            to={to}
            data-testid={`hub-card-${key}`}
            className="group rounded-3xl bg-white border border-[#E9E6DF] p-6 flex items-start gap-4 hover:border-[#B5B0A2] hover:shadow-[0_10px_30px_rgba(14,56,43,0.08)] transition-all"
          >
            <span className="shrink-0 w-12 h-12 rounded-2xl flex items-center justify-center" style={{ background: bg, color }}>
              <Icon className="w-6 h-6" />
            </span>
            <div className="min-w-0">
              <div className="flex items-center gap-2">
                <h3 className="font-serif text-xl font-semibold text-[#0E382B]">{t(`hub.${key}`)}</h3>
                <ArrowRight className="w-4 h-4 text-[#B5B0A2] group-hover:translate-x-1 group-hover:text-[#0E382B] transition-all" />
              </div>
              <p className="mt-1 text-sm text-[#52635B]">{t(`hub.${key}Desc`)}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
